var _rect, _path, _path2, _rect2, _path3, _path4, _rect3, _rect4, _rect5, _rect6, _circle, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 148,
    rx: 74,
    fill: "#F2F5F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9667 46.7897C22.9667 46.7897 16.9172 46.8103 16.9172 52.8391C16.9172 46.8103 10.8678 46.7897 10.8678 46.7897C10.8678 46.7897 16.9172 46.7691 16.9172 40.7402C16.9172 46.7691 22.9667 46.7897 22.9667 46.7897Z",
    fill: "white",
    stroke: "#99A0AE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.237 95.4167C141.237 95.4167 135.187 95.4372 135.187 101.466C135.187 95.4372 129.138 95.4167 129.138 95.4167C129.138 95.4167 135.187 95.396 135.187 89.3672C135.187 95.396 141.237 95.4167 141.237 95.4167Z",
    fill: "white",
    stroke: "#99A0AE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 57.6333,
    y: 28.6484,
    width: 65.9744,
    height: 83.7857,
    rx: 3.02661,
    transform: "rotate(15.9553 57.6333 28.6484)",
    fill: "#E1E4EA",
    stroke: "#99A0AE",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.52 42.682L96.4991 109.21C94.8319 115.042 88.7576 118.415 82.9264 116.748L37.2955 103.702C33.2906 102.557 30.9755 98.3878 32.1205 94.3828L52.0867 24.5465C52.5502 22.9255 54.2385 21.9879 55.8595 22.4514L113.424 38.9092C115.045 39.3727 115.983 41.061 115.52 42.682Z",
    fill: "white",
    stroke: "#99A0AE",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9262 116.747L32.9592 102.438C29.5118 101.453 27.5141 97.8663 28.4997 94.4189C29.3742 91.3601 32.3191 89.4409 35.38 89.7526L35.5885 89.7726L86.7757 95.2346C81.6757 94.8398 76.8431 98.0602 75.3815 103.173C73.7143 109.004 77.0876 115.078 82.9262 116.747Z",
    fill: "#CACFD8",
    stroke: "#99A0AE",
    strokeMiterlimit: 10
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 74.3536,
    y: 77.1123,
    width: 3.65196,
    height: 10.0615,
    rx: 1.51331,
    transform: "rotate(15.9553 74.3536 77.1123)",
    fill: "#E1E4EA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 86.1313,
    y: 77.9951,
    width: 3.65196,
    height: 12.4496,
    rx: 1.51331,
    transform: "rotate(15.9553 86.1313 77.9951)",
    fill: "#E1E4EA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3794,
    y: 73.5781,
    width: 3.65196,
    height: 15.3903,
    rx: 1.51331,
    transform: "rotate(15.9553 81.3794 73.5781)",
    fill: "#E1E4EA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 90.9669,
    y: 84.4199,
    width: 3.65196,
    height: 7.60192,
    rx: 1.51331,
    transform: "rotate(15.9553 90.9669 84.4199)",
    fill: "#E1E4EA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57.1559,
    cy: 75.2532,
    r: 10.3301,
    transform: "rotate(15.9553 57.1559 75.2532)",
    fill: "white",
    stroke: "#99A0AE",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6007 81.0431C49.7442 78.0973 52.8172 76.3621 55.9217 76.8916C54.4122 76.1055 53.6116 74.3423 54.0977 72.6422C54.6531 70.6995 56.6782 69.5749 58.6208 70.1303C60.5635 70.6858 61.6881 72.7109 61.1327 74.6535C60.6467 76.3536 59.0351 77.4272 57.3381 77.2966C60.2533 78.488 61.9447 81.5851 61.3585 84.69C59.219 85.6441 56.7449 85.8796 54.3164 85.1853C51.8881 84.4911 49.9125 82.9836 48.6007 81.0431Z",
    fill: "#99A0AE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9217 76.8916L55.8377 77.3845C56.0804 77.4259 56.3171 77.2844 56.3956 77.051C56.4741 76.8177 56.371 76.5619 56.1527 76.4481L55.9217 76.8916ZM48.6007 81.0431L48.1346 80.8622C48.0753 81.015 48.0946 81.1873 48.1865 81.3231L48.6007 81.0431ZM57.3381 77.2966L57.3765 76.798C57.131 76.7791 56.9083 76.9418 56.8516 77.1814C56.7949 77.421 56.921 77.6662 57.149 77.7594L57.3381 77.2966ZM61.3585 84.69L61.5621 85.1467C61.7119 85.0799 61.8194 84.9439 61.8498 84.7828L61.3585 84.69ZM56.0058 76.3987C52.6674 75.8294 49.3642 77.6945 48.1346 80.8622L49.0668 81.224C50.1241 78.5001 52.9669 76.8949 55.8377 77.3845L56.0058 76.3987ZM53.6169 72.5048C53.0643 74.4378 53.9748 76.4415 55.6908 77.3351L56.1527 76.4481C54.8496 75.7696 54.1589 74.2468 54.5784 72.7796L53.6169 72.5048ZM58.7583 69.6496C56.5501 69.0183 54.2482 70.2966 53.6169 72.5048L54.5784 72.7796C55.0579 71.1025 56.8062 70.1316 58.4834 70.6111L58.7583 69.6496ZM61.6134 74.791C62.2448 72.5828 60.9665 70.2809 58.7583 69.6496L58.4834 70.6111C60.1606 71.0906 61.1315 72.8389 60.652 74.5161L61.6134 74.791ZM57.2998 77.7951C59.2288 77.9436 61.0608 76.724 61.6134 74.791L60.652 74.5161C60.2325 75.9833 58.8413 76.9108 57.3765 76.798L57.2998 77.7951ZM61.8498 84.7828C62.4802 81.444 60.662 78.1149 57.5273 76.8337L57.149 77.7594C59.8446 78.8612 61.4092 81.7263 60.8672 84.5973L61.8498 84.7828ZM61.1548 84.2334C59.1187 85.1414 56.7652 85.3654 54.4538 84.7046L54.1789 85.6661C56.7246 86.3939 59.3193 86.1469 61.5621 85.1467L61.1548 84.2334ZM54.4538 84.7046C52.1427 84.0438 50.2634 82.6099 49.0149 80.7631L48.1865 81.3231C49.5616 83.3573 51.6335 84.9383 54.1789 85.6661L54.4538 84.7046Z",
    fill: "#99A0AE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.865 52.1871L105.64 46.7393L100.022 49.6589L103.876 36.1787L112.719 38.7069L108.865 52.1871Z",
    fill: "#CACFD8",
    stroke: "#99A0AE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyView);
export default __webpack_public_path__ + "static/media/empty-view.e95d8b1b3ec75f7818f62ca5c4e163fd.svg";
export { ForwardRef as ReactComponent };